import React from 'react'

function NoWishList() {
  // Generate unique IDs to prevent conflicts when multiple instances are rendered
  const uniqueId = React.useMemo(() => Math.random().toString(36).substr(2, 9), []);
  
  return (
    <div>
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter={`url(#filter0_dd_${uniqueId})`}>
          <rect
            x="8"
            y="8"
            width="56"
            height="56"
            rx="28"
            fill="white"
          />
          <path
            d="M51.0047 32.6653V28.4969C51.0047 24.353 47.6454 20.9938 43.5016 20.9938H28.4953C24.3515 20.9938 20.9922 24.353 20.9922 28.4969V43.5031C20.9922 47.647 24.3515 51.0063 28.4953 51.0063H32.6637"
            stroke={`url(#paint0_linear_${uniqueId})`}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.332 36H37.6668"
            stroke={`url(#paint1_linear_${uniqueId})`}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.332 29.3306H44.3362"
            stroke={`url(#paint2_linear_${uniqueId})`}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.6657 36.4168C27.5565 36.4182 27.4512 36.3761 27.373 36.2998C27.2949 36.2235 27.2502 36.1192 27.2489 36.01V36C27.2489 35.7698 27.4355 35.5832 27.6657 35.5832C27.8959 35.5832 28.0826 35.7698 28.0826 36C28.0826 36.2302 27.8959 36.4168 27.6657 36.4168"
            stroke={`url(#paint3_linear_${uniqueId})`}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.6657 29.7474C27.5565 29.7487 27.4512 29.7066 27.373 29.6303C27.2949 29.554 27.2502 29.4498 27.2489 29.3406V29.3306C27.2489 29.1003 27.4355 28.9137 27.6657 28.9137C27.8959 28.9137 28.0826 29.1003 28.0826 29.3306C28.0826 29.5608 27.8959 29.7474 27.6657 29.7474"
            stroke={`url(#paint4_linear_${uniqueId})`}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.2344 41.9942V48.7553C39.2344 49.9985 40.2422 51.0063 41.4853 51.0063H48.9884C49.5854 51.0063 50.158 50.7691 50.5801 50.347C51.0022 49.9248 51.2394 49.3523 51.2394 48.7553V42.1023"
            stroke={`url(#paint5_linear_${uniqueId})`}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M52.6742 43.2488L46.1085 37.9962C45.5605 37.5578 44.7817 37.5578 44.2337 37.9962L37.668 43.2488"
            stroke={`url(#paint6_linear_${uniqueId})`}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <filter
            id={`filter0_dd_${uniqueId}`}
            x="-9.53674e-07"
            y="-9.53674e-07"
            width="72"
            height="72"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood
              floodOpacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="-2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result={`effect1_dropShadow_${uniqueId}`}
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="2" dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
            />
            <feBlend
              mode="normal"
              in2={`effect1_dropShadow_${uniqueId}`}
              result={`effect2_dropShadow_${uniqueId}`}
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2={`effect2_dropShadow_${uniqueId}`}
              result="shape"
            />
          </filter>
          <linearGradient
            id={`paint0_linear_${uniqueId}`}
            x1="35.9984"
            y1="20.9938"
            x2="35.9984"
            y2="51.0063"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6B349A" />
            <stop offset="1" stopColor="#4C37C3" />
          </linearGradient>
          <linearGradient
            id={`paint1_linear_${uniqueId}`}
            x1="35.9994"
            y1="35.1663"
            x2="35.9994"
            y2="36.8337"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6B349A" />
            <stop offset="1" stopColor="#4C37C3" />
          </linearGradient>
          <linearGradient
            id={`paint2_linear_${uniqueId}`}
            x1="39.3341"
            y1="28.4969"
            x2="39.3341"
            y2="30.1642"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6B349A" />
            <stop offset="1" stopColor="#4C37C3" />
          </linearGradient>
          <linearGradient
            id={`paint3_linear_${uniqueId}`}
            x1="27.6657"
            y1="35.1663"
            x2="27.6657"
            y2="36.8337"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6B349A" />
            <stop offset="1" stopColor="#4C37C3" />
          </linearGradient>
          <linearGradient
            id={`paint4_linear_${uniqueId}`}
            x1="27.6657"
            y1="28.4969"
            x2="27.6657"
            y2="30.1643"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6B349A" />
            <stop offset="1" stopColor="#4C37C3" />
          </linearGradient>
          <linearGradient
            id={`paint5_linear_${uniqueId}`}
            x1="45.2369"
            y1="41.9942"
            x2="45.2369"
            y2="51.0063"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6B349A" />
            <stop offset="1" stopColor="#4C37C3" />
          </linearGradient>
          <linearGradient
            id={`paint6_linear_${uniqueId}`}
            x1="45.1711"
            y1="37.6674"
            x2="45.1711"
            y2="43.2488"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6B349A" />
            <stop offset="1" stopColor="#4C37C3" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  )
}

export default NoWishList